import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { axiosInstance, API } from "../../utils/api";

const VerifyEmail = () => {
  const navigate = useNavigate();
  const { token } = useParams();
  const [verifying, setVerifying] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [debugInfo, setDebugInfo] = useState(null);

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        // First, check the token status for debugging
        try {
          const checkResponse = await axiosInstance.get(`${API}/auth/check-token/${token}`);
          setDebugInfo(checkResponse.data);
          console.log('Token check:', checkResponse.data);
        } catch (e) {
          console.log('Token check failed:', e);
        }

        // Now try to verify
        const response = await axiosInstance.get(`${API}/auth/verify-email/${token}`);
        setSuccess(true);
        setVerifying(false);
        toast.success('Email verified successfully!');
        
        setTimeout(() => {
          navigate('/dashboard');
        }, 2000);
      } catch (err) {
        const errorDetail = err.response?.data?.detail || 'Verification failed';
        setError(errorDetail);
        setVerifying(false);
        toast.error('Verification failed');
        console.error('Verification error:', err.response?.data);
      }
    };

    if (token) {
      verifyEmail();
    }
  }, [token, navigate]);

  return (
    <div className="verify-email-page">
      <div className="verify-email-container">
        <div className="verify-email-content">
          <img src="/CXrecon logo.png" alt="CX/recon" className="verify-logo" />
          
          {verifying && (
            <div className="verifying-state">
              <div className="spinner"></div>
              <h2>Verifying your email...</h2>
              <p>Please wait while we confirm your email address.</p>
            </div>
          )}
          
          {success && !verifying && (
            <div className="success-state">
              <div className="success-icon">✅</div>
              <h2>Email Verified Successfully!</h2>
              <p>Your email has been confirmed. You can now access all features.</p>
              <p className="redirect-message">Redirecting to dashboard...</p>
            </div>
          )}
          
          {error && !verifying && (
            <div className="error-state">
              <div className="error-icon">❌</div>
              <h2>Verification Failed</h2>
              <p>{error}</p>
              {debugInfo && (
                <div className="debug-info" style={{ marginTop: '1rem', padding: '1rem', background: '#f5f5f5', borderRadius: '8px', fontSize: '0.85rem', textAlign: 'left' }}>
                  {debugInfo.already_verified ? (
                    <div style={{ textAlign: 'center' }}>
                      <p style={{ color: 'green', fontWeight: 'bold', fontSize: '1rem' }}>✓ Your email is already verified!</p>
                      <p>You can simply log in to your account.</p>
                      <button 
                        className="retry-btn" 
                        onClick={() => navigate('/')}
                        style={{ marginTop: '1rem', background: '#00897b', color: 'white', border: 'none', padding: '0.75rem 1.5rem', borderRadius: '8px', cursor: 'pointer' }}
                      >
                        Go to Login
                      </button>
                    </div>
                  ) : (
                    <>
                      <p><strong>Debug Info:</strong></p>
                      <p>Token length: {debugInfo.token_length}</p>
                      <p>Exact match: {debugInfo.exact_match_found ? 'Yes' : 'No'}</p>
                      <p>Partial match: {debugInfo.partial_match_found ? 'Yes' : 'No'}</p>
                      <p>Unverified users in DB: {debugInfo.unverified_users_count}</p>
                    </>
                  )}
                </div>
              )}
              {(!debugInfo || !debugInfo.already_verified) && (
                <button 
                  className="back-to-dashboard-btn"
                  onClick={() => navigate('/dashboard')}
                >
                  Go to Dashboard
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
